export const constants = {};
export const notifications = {};

export const requestType = {
  POST: "post",
  PUT: "put",
  GET: "get",
  DELETE: "delete",
  PATCH: "patch",
};

export const apiHeaders = {
  contentType: "Content-Type",
  application_json: "application/json",
  multipart_data: "multipart/form-data",
  language: "LANG",
  authorization: "Authorization",
};
export const endPoints = {
  // Auth APIS
  login: "admin-login",
  changePassword: "admin/change-password",
  resetPassword: "admin/reset-password",
  forgotPassword: "admin/forgot-password",

  //dashboard APIS
  getDashboardData: "/get-dashboard-data",
  activeWorkersToday: "active-workers-today",

  // Worker APIS
  fetchWorkers: "all-workers",
  fetchArchivedWorkers: "all-archived-workers",
  archiveWorker: "archive-worker",
  unarchiveWorker: "unarchive-worker",
  createWorker: "create-worker",
  updateWorker: "update-worker-by-admin",
  workerAttendance: "worker-attendance",

  // Attendance APIS
  fetchAttendance: "attendance-data",

  // Admin Attendance APIs
  getWorkerAttendance: "worker-attendance",
  getAttendanceSummary: "attendance/summary",
  allWorkersAttendance: "all-workers-attendance",
  adjustAttendance: "adjust",
  adjustmentHistory: "adjustment-history",
  addAttendance: "add-record",
  deleteAttendance: "delete",

  // Create Task APIS
  createWorkerTask: "job/create",
  fetchAllTasks: "job/fetch",
  taskStats: "job/stats",
  jobUpdate: "job/update",
  jobDelete: "job/delete",
  jobDetail: "job-detail",
  getSubmittedImages: "job/images",
  viewJobSubTasks: "job/sub-task/view",
  addJobSubTask: "job/sub-task/add",
  removeJobSubTask: "job/sub-task/remove",

  // Group Chat APIS
  sendGroupMessage: "group/message/admin",

  // Notification APIS
  createNotification: "create-notification",
  updateNotification: "update-notification",
  getNotificationsByType: "get-notifications-by-type",
  fetchAllNotifications: "get-notifications",
  getNotificationById: "get-notifications-by-id",
  resendNotification: "resend-notification",
  marksAllRead: "mark-all-as-read",

  // Activity APIS
  getActivity: "all-activities",
  getEmployeeAnalytics: "employee-chart-data",

  // Settings APIS
  getSettings: "settings-get",
  updateSettings: "update-settings",

  // Custom Form APIS
  getForms: "custom-form/all",
  createForm: "custom-form/create",
  updateForm: "custom-form/update",
  deleteForm: "custom-form/delete",
  getFormById: "custom-form",
  getSubmittedForms: "activity/all",
};
